export const REDUCER_NAME = 'reassign'

export const REASSIGNMENT_TREATING_PHYSICIAN = 'REASSIGNMENT_TREATING_PHYSICIAN'
export const REASSIGNMENT_PARTNER_PHYSICIAN = 'REASSIGNMENT_PARTNER_PHYSICIAN'

export const REASSIGNMENT_VALUE_LIST = [
    {
        id: REASSIGNMENT_TREATING_PHYSICIAN,
        value: 'Reassign to treating physician',
    },
    {
        id: REASSIGNMENT_PARTNER_PHYSICIAN,
        value: 'Reassign to partner physician',
    },
]



// WEBPACK FOOTER //
// ./src/modules/treatment/state/reassign/const.js